import React from 'react';

const AboutCard = props => {
   const { title, children, icon, theme = 'dark', className, style } = props;

   let textColor = '';
   let backgroundColor = '';

   if (theme === 'dark') {
      textColor = 'color-white';
      backgroundColor = 'background-dark';
   } else if (theme === 'soft-red') {
      textColor = 'color-secondary';
      backgroundColor = 'background-soft-red';
   }

   return (
      <div
         className={`about-card ${backgroundColor} ${className || ''}`}
         style={style}
      >
         <img src={icon} width={50} alt="icon" />
         <h2 className={`quicksand ${textColor} about-card-title`}>{title}</h2>
         {children}
      </div>
   );
};

export default AboutCard;



// WEBPACK FOOTER //
// ./src/components/About/about-card.js